<template>
  <div class="role-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="角色名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入角色名称" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="角色类型" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="1">平台</a-radio>
          <a-radio :value="0">社区</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="角色备注" prop="note">
        <a-textarea v-model="form.note" placeholder="请输入角色备注"></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import RoleService from '@/io/role.js';

  export default {
    name: 'RoleInfo',
    data() {
      return {
        id: this.$route.params.id,
        form: {
          name: null,
          type: null,
          note: null,
        },
        rules: {
          name: [
            {
              required: true,
              message: '请输入角色名称'
            }
          ],
          type: [
            {
              required: true,
              message: '请选择角色类型'
            }
          ]
        }
      }
    },
    mounted () {
      this.initPage();
    },
    methods: {
      initPage() {
        if (this.id) {
          RoleService.info(this.id).then(res => {
            this.form.name = res.title;
            this.form.type = res.type;
            this.form.note = res.describe;
          }).catch(err => {});
        }
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            RoleService.edit(
              this.id,
              this.form.name,
              this.form.type,
              this.form.note
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            RoleService.add(
              this.form.name,
              this.form.type,
              this.form.note
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        });
      },
      cancel() {
        this.$router.push('/platform/role_manage');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>